import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import Setting from '@appblocks/codegeneration/SettingsConfigurations/settings/Setting';
import TableField from '@appblocks/codegeneration/SettingsConfigurations/TableField';
import TableItem from '@appblocks/codegeneration/SettingsConfigurations/TableItem';
import LUISItem from '@appblocks/codegeneration/SettingsConfigurations/LUISItem';
import LUISItemOption from '@appblocks/codegeneration/SettingsConfigurations/LUISItemOption';
import LUISGroup from '@appblocks/codegeneration/SettingsConfigurations/LUISGroup';
import SocketConnection from '@appblocks/codegeneration/SettingsConfigurations/SocketConnection';
import LCDGroup from '@appblocks/codegeneration/SettingsConfigurations/LCDGroup';
import LCDImage from '@appblocks/codegeneration/SettingsConfigurations/LCDImage';
import DSGroup from '@appblocks/codegeneration/SettingsConfigurations/DSGroup';
import ModbusTableItem from '@appblocks/codegeneration/SettingsConfigurations/modbus/ModbusTableItem';
import ModbusDevice from '@appblocks/codegeneration/SettingsConfigurations/modbus/ModbusDevice';
import ModbusDeviceRegister from '@appblocks/codegeneration/SettingsConfigurations/modbus/ModbusDeviceRegister';
import HTTPHeader from '@appblocks/codegeneration/SettingsConfigurations/HTTPHeader';
import LinkedSetting from '@appblocks/codegeneration/SettingsConfigurations/LinkedSetting';
import HTTPServerEndpoint from '@appblocks/codegeneration/SettingsConfigurations/HTTPServerEndpoint';
import Variable from '@appblocks/codegeneration/SettingsConfigurations/Variable';
import MQTTTopic from '@appblocks/codegeneration/SettingsConfigurations/MQTTTopic';
import Timer from '@appblocks/codegeneration/SettingsConfigurations/Timer';
import Crontab from '@appblocks/codegeneration/SettingsConfigurations/Crontab';
import UnoWireSensor from '@appblocks/codegeneration/SettingsConfigurations/UnoWireSensor';
import UnoWireSensorValue from '@appblocks/codegeneration/SettingsConfigurations/UnoWireSensorValue';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import Command from '@appblocks/codegeneration/SettingsConfigurations/Command';
import LogPair from '@appblocks/codegeneration/SettingsConfigurations/LogPair';
import Widget from '@appblocks/codegeneration/SettingsConfigurations/Widget';
import DisplayScreen from '@appblocks/codegeneration/SettingsConfigurations/DisplayScreen';
import CustomFeature from '@appblocks/codegeneration/SettingsConfigurations/CustomFeature';
import CustomFeatureSetting from '@appblocks/codegeneration/SettingsConfigurations/CustomFeatureSetting';
import CustomFeatureCodeBlock from '@appblocks/codegeneration/SettingsConfigurations/CustomFeatureCodeBlock';
import CustomFeatureSettingOption from '@appblocks/codegeneration/SettingsConfigurations/CustomFeatureSettingOption';
import CustomFeatureVariable from '@appblocks/codegeneration/SettingsConfigurations/CustomFeatureVariable';
import ConsolTableItem from '@appblocks/codegeneration/SettingsConfigurations/ConsoleTableItem';
import ConditionExpression from '@appblocks/codegeneration/SettingsConfigurations/ConditionExpression';
import TableUpdateFieldValue from '@appblocks/codegeneration/SettingsConfigurations/TableUpdateFieldValue';

const SettingsMap: { [featureId: string]: typeof BaseFeature } = {
    stg_setting: Setting,
    tbl_table: TableItem,
    tbl_field: TableField,
    luis_group: LUISGroup,
    lcd_group: LCDGroup,
    lcd_image: LCDImage,
    luis_item: LUISItem,
    ds_group: DSGroup,
    luis_item_option: LUISItemOption,
    socket_connection: SocketConnection,
    modbus_table_item: ModbusTableItem,
    modbus_device: ModbusDevice,
    modbus_device_register: ModbusDeviceRegister,
    http_header: HTTPHeader,
    log_key_value: LogPair,
    condition_expression: ConditionExpression,
    linked_setting: LinkedSetting,
    http_server_endpoint: HTTPServerEndpoint,
    variable: Variable,
    mqtt_topic: MQTTTopic,
    widget: Widget,
    timer: Timer,
    crontab: Crontab,
    unowiresensor: UnoWireSensor,
    unowiresensorval: UnoWireSensorValue,
    command: Command,
    display_screen: DisplayScreen,
    custom_feature: CustomFeature,
    custom_feature_setting: CustomFeatureSetting,
    custom_feature_code_block: CustomFeatureCodeBlock,
    custom_feature_setting_option: CustomFeatureSettingOption,
    custom_feature_variable: CustomFeatureVariable,
    console_table_item: ConsolTableItem,
    table_update_field_value: TableUpdateFieldValue,
};

export default class SettingsConfigurations {
    static getItem(itemId: string, project: ProjectConfiguration) {
        if (SettingsMap[itemId] !== undefined) {
            return new SettingsMap[itemId]();
        }

        return undefined;
    }

    static getList() {
        return Object.keys(SettingsMap);
    }
}
